import Icon from "@/utils/antdIcon";
import React, { useCallback } from "react";
import { DownloadIcon, FailAllIcon, RetrAllIcon, SuccessAllIcon, SuccessIcon } from "../Icons";
import { GlobalStatus, GlobalStatusText } from "../../type";
import "./index.less";

interface IProps {
  status: GlobalStatus;
  currentSuccessTaskCount: number;
  totalTaskCount: number;
  draggable?: boolean;
  className?: string;
}
const PanelHeader = (props: IProps) => {
  const { status, currentSuccessTaskCount, totalTaskCount, draggable, className } = props;
  const createDOM = useCallback(() => {
    switch (status) {
      case GlobalStatus.PROGRESS_ALL:
        return (
          <div className="download-herder-item">
            <Icon component={DownloadIcon} />
            <span>
              {GlobalStatusText.PROGRESS_ALL}
              {`${currentSuccessTaskCount}/${totalTaskCount}`}
            </span>
          </div>
        );
      case GlobalStatus.CANCEL_ALL:
        return (
          <div className="download-herder-item">
            <Icon component={RetrAllIcon} />
            <span>{GlobalStatusText.CANCEL_ALL}</span>
          </div>
        );
      case GlobalStatus.SUCCESS_ALL:
        return (
          <div className="download-herder-item">
            <Icon component={SuccessAllIcon} />
            <span>{GlobalStatusText.SUCCESS_ALL}</span>
          </div>
        );
      case GlobalStatus.MOIETY_ERROR:
        return (
          <div className="download-herder-item">
            <Icon component={FailAllIcon} />
            <span>{GlobalStatusText.MOIETY_ERROR}</span>
          </div>
        );
      default:
      case GlobalStatus.ERROR_ALL:
        return (
          <div className="download-herder-item">
            <Icon component={FailAllIcon} />
            <span>{GlobalStatusText.ERROR_ALL}</span>
          </div>
        );
    }
  }, [status, currentSuccessTaskCount, totalTaskCount]);
  return (
    <div className={`download-herder-box ${draggable ? "draggable" : ""} ${className || ""}`}>
      {createDOM()}
    </div>
  );
};

export default PanelHeader;
